import { lazy } from 'react';

import Profile from '@src/views/pages/Profile';
import { SigningOfTerms } from '@src/views/pages/SigningOfTerms';
import { NoticeOfUnsignedTerms } from '@src/views/pages/NoticeOfUnsignedTerms';
import { TermsService } from '@src/views/pages/AcceptTerms';

export const Pages = [
  {
    path: '/pages/account-settings',
    component: Profile,
    meta: {
      action: 'view_account_settings',
      resource: 'ACL',
    },
  },
  {
    path: '/registration/wizard',
    component: lazy(() => import('../../views/pages/RegistrationWizard')),
    layout: 'BlankLayout',
    meta: {
      action: 'view_registration_wizard',
      resource: 'ACL',
    },
  },
  {
    path: '/verify/documentary',
    component: lazy(() => import('../../views/pages/SendDocumentary')),
    layout: 'BlankLayout',
    meta: {
      action: 'view_dashboard',
      resource: 'ACL',
    },
  },
  {
    path: '/contract/merchant',
    component: lazy(() => import('../../views/pages/ContractMerchant')),
    layout: 'BlankLayout',
    meta: {
      action: 'view_contract_merchant',
      resource: 'ACL',
    },
  },
  {
    path: '/signing-of-terms',
    component: SigningOfTerms,
    layout: 'BlankLayout',
    meta: {
      action: 'view_dashboard',
      resource: 'ACL',
    },
  },
  // rota para termos nao assinado
  {
    path: '/notice-of-terms',
    component: NoticeOfUnsignedTerms,
    layout: 'BlankLayout',
    meta: {
      action: 'view_dashboard',
      resource: 'ACL',
    },
  },

  {
    // rota para os termos
    path: '/termos',
    component: TermsService,
    layout: 'BlankLayout',
    exact: true,
    meta: {
      action: 'view_dashboard',
      resource: 'ACL',
    },
  },
];
